import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { MatIconModule } from "@angular/material/icon";

@Component({
    selector: 'que-display-auto-fill-field',
    imports: [NgIf, TranslateDirective, TranslatePipe, MatIconModule],
    templateUrl: './display-auto-fill-field.component.html',
    styleUrls: ['./display-auto-fill-field.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DisplayAutoFillFieldComponent {
  @Input() name: string | undefined;
}
